var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53845 17C3.95887 15.1724 0.506084 10.6795 1.05894 6.1963C1.4939 2.94575 5.04866 -0.48741 9.28084 1.67773C12.8216 3.48914 13.4354 7.9054 11.6927 10.4293M9.28831 5.59448C8.54511 4.25413 6.85842 3.77072 5.51807 4.51392C4.17771 5.25713 3.6943 6.94382 4.43751 8.28417",
    stroke: "#FF1744",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarker);
export default __webpack_public_path__ + "static/media/icon-marker.2fd053a367cd55af86e1fc3afd79bf65.svg";
export { ForwardRef as ReactComponent };